import { render } from "./minMax.vue?vue&type=template&id=efa01d5a"
import script from "./minMax.vue?vue&type=script&lang=js"
export * from "./minMax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__